import {
  IApiEpBillingBill,
  IApiEpBillingPaymentProvider,
  IApiEpBillingProductPurchaseRes,
  IApiEpBillingRecurringPayment,
} from "@smp/api";
import { RefObject } from "react";

import { Cloudpayments } from "./cloudpayments";
import { Maib } from "./maib";
import { Manual } from "./manual";
import { Paddle } from "./paddle";
import { Paypal } from "./paypal";
import { Qiwi } from "./qiwi";
import { Stub } from "./stub";
import { Yakassa } from "./yakassa";

export const Payment = ({
  onClose,
  refDialog,
  status,
  recurring,
  description,
  provider,
  bill,
  onReachGoal,
  redirectDisabled,
}: {
  onClose: (fireSuccessAction?: boolean) => void;
  onReachGoal: () => void;
  status: IApiEpBillingProductPurchaseRes["status"] | undefined;
  description?: string;
  refDialog?: RefObject<HTMLDivElement>;
  recurring?: IApiEpBillingRecurringPayment;
  provider?: IApiEpBillingPaymentProvider;
  bill?: IApiEpBillingBill;
  redirectDisabled?: boolean;
}) => {
  if (!status || !provider) {
    return null;
  }

  if (status === "complete") {
    return <Stub />;
  }

  if (recurring && status === "confirm_required") {
    if (recurring.provider_id === "cloudpayments") {
      return (
        <Cloudpayments
          description={description}
          onClose={onClose}
          onReachGoal={onReachGoal}
          provider={provider}
          recurringPayment={recurring}
          refDialog={refDialog}
        />
      );
    }
    if (recurring.provider_id === "maib") {
      return <Maib recurringPayment={recurring} onClose={onClose} />;
    }
    if (recurring.provider_id === "paypal") {
      return (
        <Paypal
          recurringPayment={recurring}
          onClose={onClose}
          onReachGoal={onReachGoal}
        />
      );
    }
    if (recurring.provider_id === "paddle") {
      return <Paddle recurringPayment={recurring} onClose={onClose} />;
    }
  }

  if (bill && status === "payment_required") {
    if (bill.payment_provider === "cloudpayments") {
      return (
        <Cloudpayments
          onReachGoal={onReachGoal}
          bill={bill}
          onClose={onClose}
          description={description}
          provider={provider}
          refDialog={refDialog}
        />
      );
    }

    if (bill.payment_provider === "maib") {
      return <Maib bill={bill} onClose={onClose} />;
    }

    if (bill.payment_provider === "manual") {
      return <Manual onReachGoal={onReachGoal} />;
    }

    if (bill.payment_provider === "paypal") {
      return <Paypal bill={bill} onClose={onClose} onReachGoal={onReachGoal} />;
    }

    if (bill.payment_provider === "qiwi") {
      return (
        <Qiwi
          onReachGoal={onReachGoal}
          bill={bill}
          onClose={onClose}
          description={description}
          provider={provider}
        />
      );
    }

    if (bill.payment_provider === "yakassa") {
      return (
        <Yakassa
          bill={bill}
          onClose={onClose}
          redirectDisabled={redirectDisabled}
        />
      );
    }

    if (bill.payment_provider === "paddle") {
      return <Paddle bill={bill} onClose={onClose} />;
    }
  }

  return null;
};
